module.exports = __webpack_public_path__ + "img/android.9f53dee6.png";